export const getHostWithProtocol = () => {
  const host = window.location.host;
  const protocol = window.location.protocol;
  return `${protocol}//${host}`;
};
